import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { environment } from '@environments/environment';


@Injectable({
    providedIn: 'root'
})
export class ItemsService {

    private itemCategoriesSubject$: BehaviorSubject<any> = new BehaviorSubject(null);

    itemCategories$: Observable<any> = this.itemCategoriesSubject$.asObservable();

    
    constructor(private http: HttpClient) { }

    getAll(params) {
        return this.http.get<any>(`${environment.apiUrl}/items/items`, {params} );
    }

    getItemCategories(params,updated = false) {
 
        if(this.itemCategoriesSubject$.value && !updated){
            return this.itemCategories$;
        }

        return this.http.get<any>(`${environment.apiUrl}/items/item-categories/`, params );
    }
    
    getItemCategoriesSupplier(params) {
        return this.http.get<any>(`${environment.apiUrl}/items/item-categories/supplier`, params );
    }

    getCategories(params){
        return this.http.get<any>(`${environment.apiUrl}/items/categories/`, {params});
    }


    set itemCategories(itemCategories){
        this.itemCategoriesSubject$.next(itemCategories);
    }

    get itemCategories(){
        return this.itemCategoriesSubject$.value;
    }
    
}
